import { v4 as uuid } from "uuid";
import { Images } from "../../Assets/Images/image";
import { SmallImages } from "../../Assets/Images/SmallImages";
/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    name: "Rolled Oats | Gluten free | Lab Tested",
    shortName: "Rolled Oats",
    price: 225,
    image: Images.oats,
    smallImage: SmallImages.oatSmall,
    discount: false,
    categoryName: "Healthy grains",
    ratings: 4,
    newItem: true,
    isOutOfStock: false,
  },
  {
    _id: uuid(),
    name: "Organic Cashew nuts (Kaju)",
    shortName: "Cashews",
    price: 400,
    image: Images.cashews,
    smallImage: SmallImages.cashewsSmall,
    discount: false,
    categoryName: "Nutritional Nuts",
    ratings: 4,
    isOutOfStock: false,
  },
  {
    _id: uuid(),
    name: "Organic Quinoa | (500g) | (Salvia hispanica)",
    shortName: "Quinoa",
    price: 280,
    image: Images.quinoa,
    smallImage: SmallImages.quinoaSmall,
    discount: true,
    priceBeforeDiscount: 400,
    discPerc: 30,
    categoryName: "Healthy grains",
    ratings: 3,
    sale: true,
    isOutOfStock: false,
  },
  {
    _id: uuid(),
    name: "Fresh | Organic Apples | 2kg",
    shortName: "Apples",
    price: 300,
    image: Images.apple,
    smallImage: SmallImages.appleSmall,
    discount: false,
    categoryName: "Fruits",
    ratings: 4,
    newItem: true,
    isOutOfStock: false,
  },
  {
    _id: uuid(),
    name: "Organic| Healthy| Chia Seeds | 500g",
    shortName: "Chia Seeds",
    price: 250,
    image: Images.chiaSeeds,
    discount: false,
    categoryName: "Super Seeds",
    ratings: 3,
    isOutOfStock: true,
  },
  {
    _id: uuid(),
    name: "Mixed Nuts | 4 Types | (500g)",
    shortName: "Mixed nuts",
    price: 600,
    image: Images.mixedNuts,
    smallImage: SmallImages.mixedNutSmall,
    discount: true,
    priceBeforeDiscount: 750,
    discPerc: 20,
    categoryName: "Nutritional Nuts",
    ratings: 2,
    sale: true,
    isOutOfStock: false,
  },
  {
    _id: uuid(),
    name: "Fresh StrawBerries | (250g)",
    shortName: "StrawBerries",
    price: 390,
    image: Images.strawberries,
    smallImage: SmallImages.strawberrieSmall,
    discount: false,
    categoryName: "Fruits",
    ratings: 3,
    isOutOfStock: false,
  },
  {
    _id: uuid(),
    name: "Organic Sunflower Seeds | (200g)",
    shortName: "Sunflower Seeds",
    price: 100,
    image: Images.sunflowerSeeds,
    smallImage: SmallImages.sunflowerSeeds,
    discount: false,
    categoryName: "Super Seeds",
    ratings: 5,
    isOutOfStock: false,
  },
  {
    _id: uuid(),
    name: "Organic Flax Seeds | (200g)",
    shortName: "Flax Seeds",
    price: 50,
    image: Images.flaxSeeds,
    smallImage: SmallImages.flaxSeedSmall,
    discount: false,
    categoryName: "Super Seeds",
    ratings: 5,
    isOutOfStock: false,
  },
  {
    _id: uuid(),
    name: "Fresh | Organic Mangoes | (1kg)",
    shortName: "Mangoes",
    price: 120,
    image: Images.mangoes,
    smallImage: SmallImages.mangoeSmall,
    discount: false,
    categoryName: "Fruits",
    ratings: 3,
    isOutOfStock: false,
  },
  {
    _id: uuid(),
    name: "Farm fresh | Red Onions | (1kg)",
    shortName: "Red Onions",
    price: 50,
    image: Images.onions,
    smallImage: SmallImages.onionSmall,
    discount: false,
    categoryName: "Vegetables",
    ratings: 1,
    isOutOfStock: false,
  },
  {
    _id: uuid(),
    name: "Farm fresh | Spinach | (250g)",
    shortName: "Spinach",
    price: 80,
    image: Images.spinach,
    smallImage: SmallImages.spinachSmall,
    discount: false,
    categoryName: "Vegetables",
    ratings: 4,
    isOutOfStock: false,
  },
];
